import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}]]

const IconWashDryclean = createReactComponent('outline', 'wash-dryclean', 'WashDryclean', __iconNode);

export default IconWashDryclean;